import { render, staticRenderFns } from "./sm-hateoas-filter-sub-terms-select.vue?vue&type=template&id=a7a8952e&scoped=true&"
import script from "./sm-hateoas-filter-sub-terms-select.vue?vue&type=script&lang=js&"
export * from "./sm-hateoas-filter-sub-terms-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7a8952e",
  null
  
)

export default component.exports